<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs.ml-0(divider='/')
        v-breadcrumbs-item(disabled='')
          h2.ma-0 All People
    v-spacer
    v-btn.page-header__action(to='/people/add', exact='', color='primary' v-if='CR.authorization.state.isOrgAdmin || CR.authorization.state.isGod')
      | Add People
  v-container.pa-0(fluid, grid-list-lg)
    v-layout(row, nowrap)
      v-flex.pr-4
        v-data-table(v-bind:headers='headers', v-bind:items='items', :disable-initial-sort='true', hide-actions)
          template(slot='items', slot-scope='props')
            tr(:to="`/people/person/${props.item.id}`")
              td(width='30%')
                router-link(:to="`/people/person/${props.item.id}`")
                  | {{ props.item.name }}
              td.text-xs-left
                | {{ props.item.drafts_amount }}
              td.text-xs-left
                | {{ props.item.inventions_amount }}
              td(width='40%')
                div(v-for='organization in props.item.organizations')
                  | {{ organization.name }}
                  span(v-if='(organization.highest_role && organization.highest_role.name) || (organization.user_organization_status)')
                    |  ({{ organization.highest_role && organization.highest_role.name ? `${organization.highest_role.name}, ` : '' }}{{ organization.user_organization_status }})
              td(v-if='CR.authorization.state.isGod || CR.authorization.state.isOrgAdmin')
                  | {{ C.dictionary.status[props.item.status] ? C.dictionary.status[props.item.status] : props.item.status }}

      v-flex(style='position: relative; flex: 0 0 236px')
        .d-block.pt-4(style='width: 220px; position: fixed')
          .body-1.mb-0(style='position: absolute;top: 10px')
            | Sort by:
          v-text-field.input--box(v-model='C.filters.selected.name', append-icon='search', single-line, label='Search', clearable, hide-details)
          v-select.input--box(v-model='C.filters.selected.organization_id', label='All Organizations', v-bind:items='C.filters.list.organizations', single-line, item-text='name', item-value='id', :clearable='true', hide-details, v-if='C.filters.list.organizations.length > 1')
          v-select.input--box(v-model='C.filters.selected.status', v-bind:items='C.filters.list.globalStatuses', label='All Statuses', single-line, item-text='label', item-value='value', :clearable='true', hide-details, v-if='CR.authorization.state.isGod')
          v-layout(row, nowrap)
            v-flex(sm6)
              v-btn(block, @click='C.trigger.reset({ filters: C.filters.selected })')
                | Go
            v-flex(sm6)
              v-btn(block, @click='C.trigger.reset()', v-if='C.filters.selected.name || C.filters.selected.organization_id || C.filters.selected.status')
                | Reset


</template>

<script>
  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'
  import axios from '../../../node_modules/axios/dist/axios.js'

  export default {
    data () {
      return {
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name'
          },
          { text: 'Drafts', value: 'drafts', align: 'left' },
          { text: 'Inventions', value: 'inventions', align: 'left' },
          { text: 'Organizations', value: 'organizations' }
        ],
        items: [],
        CR: {
          authorization: globalSettings.authorization,
          show: globalSettings.show
        },
        C: {
          filters: {
            selected: {
              name: '',
              organization_id: null,
              status: null
            },
            list: {
              organizations: [],
              globalStatuses: [{
                label: 'Enabled',
                value: 'Active'
              }, {
                label: 'Suspended',
                value: 'Suspended'
              }, {
                label: 'Archived',
                value: 'Delete'
              }]
            }
          },
          trigger: {
            reset: (options) => {
              var component = this

              options = options || {}

              var filters = options.filters || {}

              var submitItem = {
                page: 1,
                size: 50
              }

              submitItem.name = filters.name || null
              submitItem.organization_id = filters.organization_id || null
              submitItem.status = filters.status || null

              axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/options/users`, {
                params: submitItem
              })
                   .then(response => {
                     var peopleList = (response && response.data && response.data.data && response.data.data.users) || []

                     component.items = []

                     for (var i = 0; i < peopleList.length; i++) {
                       var targetPerson = peopleList[i] || {}

                       this.items.push({
                         id: targetPerson.id,
                         name: `${targetPerson.firstname && targetPerson.lastname ? targetPerson.firstname + ' ' + targetPerson.lastname : (targetPerson.firstname || targetPerson.lastname ? targetPerson.firstname || targetPerson.lastname : '')}`,
                         organizations: targetPerson.organizations,
                         status: targetPerson.status,
                         drafts_amount: targetPerson.drafts_amount,
                         inventions_amount: targetPerson.inventions_amount
                       })
                     }

                     component.C.filters.selected.name = submitItem.name
                     component.C.filters.selected.organization_id = submitItem.organization_id
                     component.C.filters.selected.status = submitItem.status
                   })
                   .catch(errorResponse => {
                     tools.alert({
                       type: 'error',
                       errorResponse: errorResponse
                     })
                   })
            }
          },
          dictionary: {
            status: {
              'Active': 'Enabled',
              'Delete': 'Archived',
              'Suspend': 'Suspended'
            }
          }
        }
      }
    },
    created () {
      var component = this

      this.C.trigger.reset()

      tools.loggedInData({
        success: function (loggedInItem) {
          if (component.CR.authorization.state.isGod || component.CR.authorization.state.isOrgAdmin) {
            component.headers.push({
              text: 'Status',
              value: 'status'
            })
          }

          tools.getOrganizationsList({
            success: function (organizationList) {
              component.C.filters.list.organizations = organizationList
            }
          })
        },
        error: function (errorResponse) {
          tools.alert({
            type: 'error',
            errorResponse: errorResponse
          })
        }
      })
    }
  }
</script>


<style scoped>
.datatable thead th {
  overflow: hidden;
}
.side-drawer {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/People/People.vue